"use client";

import React from "react";
import Image from "next/image";
import Link from 'next/link';
import { usePathname } from "next/navigation";

interface ImageSizing {
  width: number;
  height: number;
  className?: string;
  disableLink?: boolean;
}

export default function LinkedLogo({ width, height, className, disableLink = false } : ImageSizing) {
  const pathname = usePathname();

  if (disableLink) {
    return (
      <Image src="/bluepeak-logo-blue.svg"
        alt="Bluepeak Logo"
        width={width}
        height={height}
        className={className}
      />
    );
  }

  // On the login page, link out to the Bluepeak marketing site
  if (pathname === "/") {
    return (
      <a href="https://www.mybluepeak.com" target="_blank" rel="noopener noreferrer">
        <Image src="/bluepeak-logo-blue.svg"
          alt="Bluepeak Logo"
          width={width}
          height={height}
          className={className}
        />
      </a>
    );
  }

  // If on a dashboard account page, link to account overview instead of root
  const dashboardMatch = pathname.match(/^\/dashboard\/([^/]+)/);
  const href = dashboardMatch ? `/dashboard/${dashboardMatch[1]}/account-overview` : "/";

  return (
    <Link href={href}>
        <Image src="/bluepeak-logo-blue.svg"
          alt="Bluepeak Logo"
          width={width}
          height={height}
          className={className}
        />
    </Link>
  );
}
